import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export const Pagination = ({ totalPages, currentPage, onPageChange }) => {
    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(
                    <button
                        key={i}
                        onClick={() => onPageChange(i)}
                        className={`px-1 py-1 text-xs sm:text-sm md:text-base border-2 border-solid border-bordercolor rounded-xl min-w-[2rem] ${i === currentPage
                            ? "bg-[#D9DCB0] text-black font-bold"
                            : "bg-white text-black hover:bg-gray-100"
                            }`}
                    >
                        {i}
                    </button>
                );
            }
        } else {
            pages.push(
                <button
                    key={1}
                    onClick={() => onPageChange(1)}
                    className={`px-1 py-1 text-xs sm:text-sm md:text-base border-2 border-solid border-bordercolor rounded-xl min-w-[2rem] ${currentPage === 1
                        ? "bg-[#D9DCB0] text-black font-bold"
                        : "bg-white text-black hover:bg-gray-100"
                        }`}
                >
                    1
                </button>
            );

            if (currentPage > 3) {
                pages.push(
                    <button
                        key="start-dots"
                        onClick={() => onPageChange(Math.max(currentPage - 3, 1))}
                        className="px-1 py-1 text-xs sm:text-sm md:text-base border-2 border-solid border-bordercolor rounded-xl min-w-[2rem] bg-white text-black hover:bg-gray-100"
                    >
                        ...
                    </button>
                );
            }

            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);

            for (let i = start; i <= end; i++) {
                pages.push(
                    <button
                        key={i}
                        onClick={() => onPageChange(i)}
                        className={`px-1 py-1 text-xs sm:text-sm md:text-base border-2 border-solid border-bordercolor rounded-xl min-w-[2rem] ${i === currentPage
                            ? "bg-[#D9DCB0] text-black font-bold"
                            : "bg-white text-black hover:bg-gray-100"
                            }`}
                    >
                        {i}
                    </button>
                );
            }

            if (currentPage < totalPages - 2) {
                pages.push(
                    <button
                        key="end-dots"
                        onClick={() => onPageChange(Math.min(currentPage + 3, totalPages))}
                        className="px-1 py-1 text-xs sm:text-sm md:text-base border-2 border-solid border-bordercolor rounded-xl min-w-[2rem] bg-white text-black hover:bg-gray-100"
                    >
                        ...
                    </button>
                );
            }

            pages.push(
                <button
                    key={totalPages}
                    onClick={() => onPageChange(totalPages)}
                    className={`px-1 py-1 text-xs sm:text-sm md:text-base border-2 border-solid border-bordercolor rounded-xl min-w-[2rem] ${currentPage === totalPages
                        ? "bg-[#D9DCB0] text-black font-bold"
                        : "bg-white text-black hover:bg-gray-100"
                        }`}
                >
                    {totalPages}
                </button>
            );
        }
        return pages;
    };

    return (
        <div className="flex flex-col items-center space-y-3 sm:space-y-4">
            <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3">
                {/* Previous Button */}
                <button
                    onClick={handlePrevious}
                    disabled={currentPage === 1}
                    className={`px-2 py-1 text-xs sm:text-sm md:text-base border-2 border-solid border-bordercolor rounded-xl flex items-center justify-center ${currentPage === 1
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-white text-black hover:bg-gray-100"
                        }`}
                >
                    <FiChevronLeft />
                </button>

                {/* Page Numbers */}
                {renderPageNumbers()}

                {/* Next Button */}
                <button
                    onClick={handleNext}
                    disabled={currentPage === totalPages}
                    className={`px-2 py-1 text-xs sm:text-sm md:text-base border-2 border-solid border-bordercolor rounded-xl flex items-center justify-center ${currentPage === totalPages
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-white text-black hover:bg-gray-100"
                        }`}
                >
                    <FiChevronRight />
                </button>
            </div>
        </div>
    );
};
